import { Injectable, Injector } from '@angular/core';

import { AccountProfileService } from './accountProfile.service';
import { DealershipService } from './dealership.service';
import { BaseReportService } from './reportBase.service';
import type { IGetReportData } from '@shared/models';

@Injectable()
export class ReportAccountProfileService extends BaseReportService implements IGetReportData {
    // private options: TReportOptions;
    private accountProfileService: AccountProfileService;
    private dealershipService: DealershipService;

    constructor(injector: Injector) {
        super(injector);
        this.accountProfileService = injector.get(AccountProfileService);
        this.dealershipService = injector.get(DealershipService);
    }

    public async getReportData(): Promise<any> {
        const allRows: any[] = [];

        // const promise = new Promise((resolve) => {
        const accountProfile = await this.accountProfileService.get();
        const dealership = await this.dealershipService.get();
        // const packageFeatureDesc = this.computeFeatureDesc(accountProfile);

        this.addSummaryRow(['Dealership Name:', dealership.dealershipName], allRows);
        this.addSummaryRow(['Address:', dealership.address.fullAddress], allRows);
        this.addSummaryRow(['Account Number:', accountProfile.accountNumber], allRows);
        this.addSummaryRow(['Current Package:', accountProfile.packageName], allRows);

        // this.addSummaryRow([ 'Status:', accountProfile.signupDate ], allRows);

        const signupDate = this.dateService.formatTimestamp(accountProfile.signupDate);
        this.addSummaryRow(['Signup Date:', signupDate], allRows);

        const activationDate = this.dateService.getReadableDate(accountProfile.activationInfo.activationDate);
        this.addSummaryRow(['Activation Date:', activationDate], allRows);

        const expirationDate = this.dateService.getReadableDate(accountProfile.periodInfo.expirationDate);
        this.addSummaryRow(['Expiration Date:', expirationDate], allRows);

        const psExpirationDate = this.dateService.getReadableDate(accountProfile.periodInfo.premiumSupportExpirationDate);
        this.addSummaryRow(['Premium Support Expiration Date:', psExpirationDate], allRows);

        const webHostingExpirationDate = this.dateService.getReadableDate(accountProfile.periodInfo.webHostingExpirationDate);
        this.addSummaryRow(['Web Hosting Expiration Date:', webHostingExpirationDate], allRows);

        const lastCreditsPurchasedDate = this.dateService.getReadableDate(accountProfile.creditInfo.lastCreditPurchaseDate!);
        this.addSummaryRow(['Last Credits Purchased Date:', lastCreditsPurchasedDate], allRows);

        allRows.push(undefined);
        const reportData = { 'data': allRows };
        return (reportData);
    }

    // private addSummaryRow(columns: string[], allRows: any[]) {
    //     const rowInfo = super.buildRowInfo(columns, 'summary');
    //     allRows.push(rowInfo);
    // }

    // private computeFeatureDesc(account: any): string {
    //     let desc = '';
    //     const dFeature = account.efficiency || false;
    //     const mFeature = account.customer || false;
    //     const cFeature = account.campaign || false;

    //     if (dFeature) {
    //         desc = 'Efficiency Features.';
    //     }
    //     if (mFeature) {
    //         desc += '  Customer Features.';
    //     }
    //     if (cFeature) {
    //         desc += '  Campaign Features.';
    //     }
    //     return desc;
    // }
}
